var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-closed-container"},[_c('div',{staticClass:"app-closed-inner-block"},[_c('router-view',{attrs:{"name":"appClosedLayout"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }